import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "60",
  style: {"padding":"5px","box-sizing":"border-box"},
  viewBox: "0 0 131 131"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M65.5 0c-.53 0-1.05 0-1.58.02-.07 0-.13-.02-.2-.02h-50.8C5.78 0 0 5.78 0 12.92v50.8c0 .07.01.13.02.2-.01.52-.02 1.05-.02 1.58C0 101.68 29.33 131 65.5 131S131 101.67 131 65.5 101.68 0 65.5 0",
  style: {"fill":"currentColor","transform-origin":"center","transform":"rotate(270deg)"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M104.12 66.5v16.91c0 3.08-2.5 5.58-5.58 5.58h-6.73V94c0 1.13-1.29 1.77-2.2 1.09l-8.09-6.11H65.4c-3.08 0-5.58-2.5-5.58-5.58v-7.04h19.52c4.79 0 8.68-3.9 8.68-8.68v-6.77h10.52c3.08 0 5.58 2.5 5.58 5.58Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M77.55 36.99H34.94a7.17 7.17 0 0 0-7.17 7.17V65.9a7.17 7.17 0 0 0 7.17 7.17h8.65v6.44c0 1.45 1.66 2.28 2.82 1.41l10.4-7.85h20.73a7.17 7.17 0 0 0 7.17-7.17V44.16a7.17 7.17 0 0 0-7.17-7.17ZM43.6 58.65c-2 0-3.62-1.62-3.62-3.62s1.62-3.62 3.62-3.62 3.62 1.62 3.62 3.62-1.62 3.62-3.62 3.62m12.64 0c-2 0-3.62-1.62-3.62-3.62s1.62-3.62 3.62-3.62 3.62 1.62 3.62 3.62-1.62 3.62-3.62 3.62m12.64 0c-2 0-3.62-1.62-3.62-3.62s1.62-3.62 3.62-3.62 3.62 1.62 3.62 3.62-1.62 3.62-3.62 3.62",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }